import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
// import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
// import DialogContentText from '@material-ui/core/DialogContentText';
// import DialogTitle from '@material-ui/core/DialogTitle';
import { makeStyles, Card, FormControl, InputLabel, CardContent, Typography, CardActions } from '@material-ui/core';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faAngleDown } from '@fortawesome/free-solid-svg-icons';
import DownGrey from '../../assets/down_grey.png';
import './styles.css';
import { CommonConfig } from '../../config/common-config';
import downloadImage from '../../assets/downloadImage.png';
import PreviewImage from '../../assets/previewImage.png';
import Tooltip from '@material-ui/core/Tooltip';
import PreviewModal from '../../components/modal/previewModal';

const useStyles = makeStyles((theme) => ({
    formControl: {
        margin: theme.spacing(2),
        minWidth: 500,
        fontSize: '16px',
    },
    bottomLine: {
        borderTop: '1px solid #ccc !important',
        // width: '100%',
        marginBottom: '20px',
        marginLeft: '40px',
        marginRight: '40px',
    },
    inLabel: {
        fontSize: '1.5rem',
        letterSpacing: '0.09rem',
        color: '#000000',
        fontFamily: 'Rubik !important',
    },
    cardContent: {
        paddingLeft: '24px',
        bottom: '10px',
        fontFamily: ' system-ui',
        fontWeight: '500',
        fontStyle: 'initial',
        color: '#4c4c4d',
    },
    type4: {
        margin: theme.spacing(2),
        fontSize: '1.5rem',
        fontFamily: 'Rubik',
        fontWeight: '500',
    },
    cardAction: {
        marginLeft: '30px',
        // marginBottom: '15px',
        paddingBottom: '30px',
    },
    btnFieldPositionRight: {
        position: 'absolute',
        right: '15px',
        // top: '20px',
    },
    uploadBtn: {
        width: '30px',
        fontSize: '10px !important',
        height: '20px',
        textTransform: 'capitalize',
        fontWeight: '400 !important',
    },
    border: {
        borderradius: '8px !important',
    },
    button1: {
        BorderRadius: '12px !important',
        padding: '20px',
    },
    button2: {
        margin: '0px',
    },
    downicon: {
        border: '1px solid #ababab',
        borderRadius: '6px',
        display: 'inline-flex',
        justifyContent: 'end',
        lineHeight: '37px',
        padding: '0 5px 0 10px',
        marginLeft: '14px',
        marginRight: '10px',
        marginBottom: '10px',
        '& a': {
            height: '25px',
        },
    },
    fileView: {
        marginRight: '8px',
        width: '428px !important',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        display: 'inline-block',
        overflow: 'hidden',
        marginBottom: '-6px',
        ['@media (max-width:600px)']: {
            width: '217px !important',
        },
    },
}));

export default function ListOfDocumentPopUp(props) {
    const { itecOpen, handleItecClose, selectedRow } = props;
    // const [open, setOpen] = React.useState(itecOpen);

    //console.log('props', props)
    const classes = useStyles();
    const [category, setCategory] = React.useState('Select Type of Account');
    const [open, setOpen] = React.useState(false);
    const [visible, setVisible] = React.useState(false);
    const [downloadViewFile, setDownloadViewFile] = React.useState('');

    // On Select
    const handleChange = (event) => {
        setCategory(event.target.value);
    };

    // controlled Select
    const handleClose = () => {
        setOpen(false);
    };

    const handleOpen = () => {
        setOpen(true);
    };

    const handleModalClose = () => {
        setVisible(false);
    };

    const handlePreviewModal = (file) => {
        //console.log('aaaa', file)
        setDownloadViewFile(`${CommonConfig.dev.baseUrl}/api/auth/s3download?fileName=${file}`);
        // setShowBtnLoader(true);
        setTimeout(() => {
            // setShowBtnLoader(false);
            setVisible(true);
        }, 1000);
    };

    const handleDownload = (Url) => {
        //console.log("click", invoiceUrl);
        //console.log("click", Url);
        const downloadPath = `${CommonConfig.dev.baseUrl}/api/auth/s3download?fileName=${Url}`;
        // const downloadPath = setDownloadPath(`${CommonConfig.dev.baseUrl}/api/auth/s3download?fileName=${invoiceUrl}`);
        window.location.href = downloadPath;
    };

    return (
        <div>
            <Dialog open={itecOpen} onClose={handleItecClose} maxWidth="sm" fullWidth aria-labelledby="customized-dialog-title">
                <Card>
                    <CardContent className={classes.cardContent}>
                        <Typography variant="h4" className={classes.type4}>
                            {' '}
                            List of Documents
                        </Typography>
                    </CardContent>
                    <DialogContent>
                        {selectedRow.attachmentsByCoreteam.map((path, index) => {
                            return (
                                <div key={index.toString()} className={classes.downicon}>
                                    <div className={classes.fileView}>{path.substring(path.lastIndexOf('/') + 1)}</div>
                                    <div>
                                        <span onClick={() => handlePreviewModal(path)}>
                                            <Tooltip title="Preview">
                                                <img
                                                    src={PreviewImage}
                                                    alt="PreviewImage"
                                                    className="fileView"
                                                    style={{ top: '7px', left: '8px' }}
                                                />
                                            </Tooltip>
                                        </span>
                                        <a
                                            // href={path}
                                            style={{ textDecoration: 'none', margin: '5px' }}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            // download
                                            onClick={() => handleDownload(path)}
                                        >
                                            <Tooltip title="Download">
                                                <img src={downloadImage} alt="downloadImage" className="downlaodImg downloadImgTop" />
                                            </Tooltip>
                                            {/* <Button variant="outlined" color="primary">
                                                Download
                                            </Button> */}
                                        </a>
                                    </div>
                                    <PreviewModal
                                        fileSource={downloadViewFile}
                                        visibleClose={visible}
                                        handleModalClose={handleModalClose}
                                    />
                                </div>
                            );
                        })}
                        {/* <ul>
                            {selectedRow.attachmentsByCoreteam.map((path, index) => {
                                return (
                                    <li key={index.toString()}>
                                        Document {index + 1}
                                        <a
                                            href={path}
                                            style={{ textDecoration: 'none', margin: '5px' }}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            download
                                        >
                                            <Button variant="outlined" color="primary">
                                                Download
                                            </Button>
                                        </a>
                                    </li>
                                );
                            })}
                        </ul> */}
                    </DialogContent>
                    {/* <div className={classes.bottomLine} />
                    <DialogContent>
                        <div>
                            <FormControl fullWidth>
                                <InputLabel className={classes.cardContent} htmlFor="raised-button-file" shrink>
                                    Document Three
                                </InputLabel>
                                <div className={classes.btnFieldPositionRight}>
                                    <Button color="primary" variant="outlined" className={classes.uploadBtn}>
                                        Download
                                    </Button>
                                </div>
                            </FormControl>
                        </div>
                    </DialogContent>
                    <div className={classes.bottomLine} />
                    <DialogContent>
                        <div>
                            <FormControl fullWidth>
                                <InputLabel className={classes.cardContent} htmlFor="raised-button-file" shrink>
                                    Document Four
                                </InputLabel>
                                <div className={classes.btnFieldPositionRight}>
                                    <Button color="primary" variant="outlined" className={classes.uploadBtn}>
                                        Download
                                    </Button>
                                </div>
                            </FormControl>
                        </div>
                    </DialogContent>
                    <div className={classes.bottomLine} /> */}
                </Card>
                <CardActions className={classes.cardAction}>
                    <div>
                        <Button variant="contained" color="primary" className="txt-capitalize" onClick={handleItecClose}>
                            {' '}
                            Close
                        </Button>
                    </div>
                </CardActions>
            </Dialog>
        </div>
    );
}
